module.exports = __webpack_public_path__ + "static/media/mw-image-thumb.976fc4e0.png";